export const workExperiences = [
    {
        company: "DLSU Human-X Interactions Lab (HXIL)",
        position: "Software Developer",
        description: "Co-developed AB.LY - a Visual Studio Code extension that evaluates the accessibility of a web page through its HTML.",
        startDate: "June 2024",
        endDate: "September 2024",
        logoURL: "hxil",
    },
    {
        company: "Philip Morris International - PMFTC Inc.",
        position: "INKOMPASS Intern",
        description: "Implemented an ETL process and designed databases using PowerQuery to automate the extraction of accounting and sales data used for analysis.",
        startDate: "June 2024",
        endDate: "August 2024",
        logoURL: "pmi",
    }
]